/**
 * Returns the CSS `background-position` for a spritesheet preview at a normalized
 * position (0–1). Frames are sampled at the start of each bucket, so we round to
 * the nearest frame rather than flooring, which would bias toward an earlier frame.
 */
export const getSpritesheetBackgroundPosition = ({
  position,
  frameCount,
  columns,
  frameWidth,
  frameHeight,
}: {
  position: number;
  frameCount: number;
  columns: number;
  frameWidth: number;
  frameHeight: number;
}): string => {
  const currentFrame = Math.min(frameCount - 1, Math.round(position * frameCount));
  const currentRow = Math.floor(currentFrame / columns);
  const currentColumn = currentFrame % columns;

  return `-${currentColumn * frameWidth}px -${currentRow * frameHeight}px`;
};
